import React from "react";
import "./styles.scss";
import StatisticsSAHM from "../../organims/Statistics/StatisticsSAHM";
import CardDetailDescription from "../../organims/CardDetail/cardDetailDescription";

// ---- Mock data (replace with your real data / i18n) ----
const categories = [
  { label: "Cambio climático", icon: "🌡️" },
  { label: "Género", icon: "♀️" },
  { label: "Personas", icon: "👥" },
  { label: "Prosperidad", icon: "💼" },
  { label: "Mares y costas", icon: "🌊" },
  { label: "Gobernanza", icon: "🏛️" },
  { label: "Otros recursos", icon: "📚" },
];

const logos = new Array(4).fill(0);

export default function CardDetail() {
  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-100 d-flex justify-content-md-start justify-content-lg-start flex-column">
      <div className="w-100 d-flex flex-column align-items-center">
        {
        // TODO: Add paramethers
        }
        <CardDetailDescription />
      </div>

    </div>

    </div>
  );
}
